import * as React from 'react';
import classnames from 'classnames';
import { WithRouterProps, withRouter } from 'react-router';
import Text from 'components/Text';
import Tabs, { Props as TabsProps } from 'components/Tabs';
import { mountModal } from 'lib/modal';
import TabPanel from 'components/TabPanel';

import './styles/NavigationTabs.scss';

declare var __DEV__: string;
declare var __TEST__: string;

export type Tab = {
  indicator?: boolean;
  name: string;
  path?: string;
  modal?: React.ReactElement;
};

type Props = {
  tabs: Tab[];
} & Pick<TabsProps, Exclude<keyof TabsProps, 'tabActive' | 'children'>> &
  WithRouterProps;

export function NavigationTabs(props: Props) {
  const { tabs, ...tabProps } = props;

  // TODO this check can easily be expressed via types but the rest of the component
  // would require some refactoring to accomodate that
  if (__DEV__ || __TEST__) {
    tabs.forEach((tab) => {
      if ((tab.path || tab.modal) && !(tab.path && tab.modal) === false) {
        throw new Error('NavigationTabs tab needs a path xor a modal -> must have either or');
      }
    });
  }

  const activeTab = tabs.findIndex((tab) => {
    return !!(tab.path && props.router.isActive(tab.path));
  });

  return (
    <Tabs {...tabProps} tabActive={activeTab} tabHeaderClass="NavigationTabs-tabHeader">
      {tabs.map((tab, index) => (
        <TabPanel
          key={tab.path}
          to={tab.path}
          disableActivationOnClick={!!tab.modal}
          indicator={tab.indicator}
          title={<Title active={index === activeTab}>{tab.name}</Title>}
          eventElementName="NavigationTabs"
          dataTestSelector={`${tab.name}`}
          onClick={() => {
            if (tab.path) {
              props.router.replace(tab.path);
            }

            if (tab.modal) {
              mountModal(tab.modal);
            }
          }}
        />
      ))}
    </Tabs>
  );
}

export default withRouter(NavigationTabs);

function Title(props: { active: boolean; children?: React.ReactNode }) {
  const classes = classnames('NavigationTabs-tab', {
    'NavigationTabs-tab--active': props.active,
    'NavigationTabs-tab--inactive': !props.active,
  });

  return (
    <Text size="xxsmall" className={classes}>
      {props.children}
    </Text>
  );
}
